<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.api_account_id" placeholder="请输入账户ID" clearable
                style="width: 220px" size="small"/>
      <el-input class="filter-item" v-model="listQuery.app_id" placeholder="请输入App ID" clearable
                style="width: 220px" size="small"/>
<!--      <el-select-->
<!--          v-model="listQuery.status"-->
<!--          placeholder="状态"-->
<!--          style="width: 120px"-->
<!--          class="filter-item"-->
<!--          clearable-->
<!--      >-->
<!--        <el-option label="启用" :value="'enable'"/>-->
<!--        <el-option label="禁用" :value="'disable'"/>-->
<!--        <el-option label="错误禁用" :value="'error_disable'"/>-->
<!--      </el-select>-->
      <el-date-picker
          class="filter-item"
          v-model="dateArr"
          type="datetimerange"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
          unlink-panels
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          size="small"
      ></el-date-picker>
      <el-button class="filter-item" icon="el-icon-search" :loading="listLoading" type="primary"
                 @click="handleFilter" size="small">搜索
      </el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
        size="small"
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="账户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>
      <el-table-column label="App ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.app_id }}
        </template>
      </el-table-column>
      <el-table-column label="日志类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag  v-if="scope.row.type == 'error'" type="danger">Error</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Path" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.path }}
        </template>
      </el-table-column>
      <el-table-column label="Params" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.params }}
        </template>
      </el-table-column>
      <el-table-column label="Msg Code" min-width="220" align="center">
        <template slot-scope="scope">
          {{ scope.row.msg_code }}
        </template>
      </el-table-column>
      <el-table-column label="Message" min-width="220" align="center">
        <template slot-scope="scope">
          {{ scope.row.message }}
        </template>
      </el-table-column>
      <el-table-column label="Result Raw" min-width="220" align="center">
        <template slot-scope="scope">
          <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.result_raw"
              placement="top">
            <div class="cell-content" style=" overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;">
              {{ scope.row.result_raw }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="创建时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time"/>
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column align="center" prop="created_at" label="更新时间" min-width="140">-->
<!--        <template slot-scope="scope">-->
<!--          <i class="el-icon-time"/>-->
<!--          <span>{{ scope.row.updated_at }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>-->
<!--          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="90px"
               style="width: 400px; margin-left:50px;">
        <el-form-item  label="App ID" prop="app_id">
          <el-input v-model="form.app_id"/>
        </el-form-item>
        <el-form-item  label="Api Key" prop="api_key">
          <el-input v-model="form.api_key"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status">
            <el-option label="启用" :value="'enable'"/>
            <el-option label="禁用" :value="'disable'"/>
            <el-option label="错误禁用" :value="'error_disable'"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: '',
        img: '',
        imgArray: [],
        link_type: 0,
        link: '',
        weight: 0,
        description: '',
      },
      rules: {
        app_id: [{required: true, message: 'App ID不能为空', trigger: 'blur'}],
        api_key: [{required: true, message: 'Api Key不能为空', trigger: 'blur'}],
        status: [{required: true, message: '状态不能为空', trigger: 'blur'}],
      },
      btnLoading: false,

      show: false,
      imgBase64Data: '', // the datebase64 url of created image
      dateArr:null,
    }
  },
  created() {
    this.getList()
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/api-account/request-logs',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data
        this.total = response.data.total
      }).finally(() => {
        this.listLoading = false;
      })
    },
    handleFilter() {
      console.log(this.listQuery)
      this.listQuery.page = 1
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: '',
        app_id: '',
        api_key: '',
        status: 'enable'
      }
      this.btnLoading = false
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/api-account/store',
            method: 'post',
            data: this.form
          }).then(response => {
            this.btnLoading = false
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              duration: 2000
            })
            this.getList();
          }).catch((err) => {
            this.btnLoading = false
          })
        }
      })
    },
    handleDel(val) {
      this.$confirm('确定要删除, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/backend/api-account/delete',
          method: 'post',
          data: {id: val}
        }).then(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgBase64Data, field) {
      console.log('-------- 裁剪成功 --------');
      let that = this;
      this.imgBase64Data = imgBase64Data;
      getQiniuToken().then(response => {
        let file = base64toFile(imgBase64Data, 'tmp.png')
        let key = guid() + '.png';
        let token = response.data.token
        let baseUrl = response.data.baseUrl
        let putExtra = {}
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2
        };
        var observable = qiniu.upload(file, key, token, putExtra, config)
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + '/' + key;
            that.form.img = imgUrl
            console.log(imgUrl)
          }
        }) // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      })

    },
  }
}
</script>


<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409EFF;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
